<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del" @print='print' @execute="audit"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div style="margin-top: 2px">
                    <el-button type="primary" size="mini" @click="getPro" :disabled="!btn.Pro">{{$t('getapi[7045]')}}</el-button>
                </div>
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="InvRepairInfo"
                        :filter_language="['order_status']"
                        :filter_thousandth="['so_qty','so_qty']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        @selection-change="handleSelectionChange"
                        :height="tableHeight - reduceTableHeight"
                        header-row-class-name="headerclass"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[463]')" width="120"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="order_status" :label="$t('getapi[1861]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="finance_date" :label="$t('getapi[1857]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="finance_status" :label="$t('getapi[1862]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[135]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[1210]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4168]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="base_order_no" :label="$t('getapi[3709]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="base_line_no" :label="$t('getapi[3710]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[4826]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[497]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="so_qty" :label="$t('getapi[4515]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="repair_qty" :label="$t('getapi[4827]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[4828]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="repair_workproc_name" :label="$t('getapi[4364]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="keep_person" :label="$t('getapi[4472]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="regist_person" :label="$t('getapi[4473]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[143]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <el-button type="primary" size="mini" @click="audit" :disabled="!btn.audit">{{$t('getapi[941]')}}
                    </el-button>
                </div>
                <div style="width:840px;min-width: 840px">
                    <table>
                        <tr>
                            <td colspan="9">
                                <el-divider content-position="left">{{ $t('getapi[4841]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[463]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.order_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[1861]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" :value="dataDetail.Head.order_status == 0?$t('getapi[1422]'):$t('getapi[3607]')" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[1862]') }}</td>
                            <td style="width:150px;min-width:150px" colspan="2">
                                <el-input type="text" size="mini" :value="expsfinancestatus(dataDetail.Head.finance_status)" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:60px;min-width:60px">{{ $t('getapi[1857]') }}</td>
                            <td style="width:150px;min-width:150px">
                                <el-date-picker v-model="dataDetail.Head.finance_date" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4846]') }}</td>
                            <td>
                                <routejump :urlNo="41" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.so_code"
                                           readonly
                                           size="mini"
                                           class="mcolor"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectsocode()"></i>
                                </el-input>
                                </routejump>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.so_code" v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[112]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.part_code" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[149]') }}</td>
                            <td colspan="2">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.part_version" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4847]') }}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.so_qty" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4217]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.so_type" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4232]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.so_status" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4828]') }}</td>
                            <td style="width:50px">
                                <el-input  type="text" size="mini" v-model="dataDetail.Head.routing_sequence_no " :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:100px">
                                <el-input  type="text" size="mini" v-model="dataDetail.Head.routing_short_name" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4845]') }}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.finish_qty" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4844]') }}</td>
                            <td>
                                <el-input  type="text" v-model="dataDetail.Head.base_order_no"
                                           readonly
                                           size="mini"
                                           class="mcolor"
                                           v-show="dataDetail.Head.order_status == 0"
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectbaseorderno()"></i>
                                </el-input>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.base_order_no" v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4843]') }}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.base_line_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4842]') }}</td>
                            <td colspan="2">
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.enrec_qty" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4827]') }}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.repair_qty" :readonly="!btn.repair_qty" :class="{'readO':!btn.repair_qty}"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="9">
                                <el-divider content-position="left">{{ $t('getapi[4848]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4853]') }}</td>
                            <td>
                                <routejump :urlNo="42" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.cargoposition_code"
                                           readonly
                                           size="mini"
                                           class="mcolor"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectcargo()"></i>
                                </el-input>
                                </routejump>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.cargoposition_code" v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1763]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.batch_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[1764]') }}</td>
                            <td colspan="2">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.sequence_no" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4852]') }}</td>
                            <td>
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.cargo_qty" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[410]') }}</td>
                            <td>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.create_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[135]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.create_time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                            <td>{{ $t('getapi[497]') }}</td>
                            <td colspan="2">
                                <el-input type="text" size="mini" v-model="dataDetail.Head.audit_person" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[496]') }}</td>
                            <td>
                                <el-date-picker v-model="dataDetail.Head.audit_time" type="date" size="mini"
                                                style="width:100%" :readonly="true" class="readO"></el-date-picker>
                            </td>
                        </tr>
                        <tr>
                            <td>{{ $t('getapi[4470]') }}</td>
                            <td>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.regist_person"
                                           readonly
                                           size="mini"
                                           class="mcolor"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(2)"></i>
                                </el-input>
                                </routejump>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.regist_person" v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>{{ $t('getapi[4472]') }}</td>
                            <td>
                                <routejump :urlNo="6" v-show="dataDetail.Head.order_status == 0">
                                <el-input  type="text" v-model="dataDetail.Head.keep_person"
                                           readonly
                                           size="mini"
                                           class="mcolor"

                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectperson(1)"></i>
                                </el-input>
                                </routejump>
                                <el-input type="text" size="mini" v-model="dataDetail.Head.keep_person" v-show="dataDetail.Head.order_status != 0" :readonly="true" class="readO"></el-input>
                            </td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <!--<td colspan="2" v-show="dataDetail.Head.order_status == 1">
                                <el-checkbox  v-model="dataDetail.Head.first_repair_flag"  true-label="1" false-label="0"></el-checkbox>{{ $t('getapi[4849]') }}
                            </td>-->
                        </tr>
                        <tr>
                            <td colspan="9">
                                <el-divider content-position="left">{{ $t('getapi[4855]')}}</el-divider>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="9">
                                <el-input type="textarea" size="mini" v-model="dataDetail.Head.remark"></el-input>
                            </td>
                        </tr>
                    </table>
                    <table>
                        <tr>
                            <td style="color: blue">{{$t('getapi[7117]')}}</td>
                            <td style="color: blue">{{$t('getapi[7118]')}}</td>
                        </tr>
                        <tr>
                            <td></td>
                            <td style="color: blue">{{$t('getapi[7119]')}}</td>
                        </tr>
                    </table>
                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange1"
                        @current-change="handleCurrentChange1"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange2"
                        @current-change="handleCurrentChange2"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="100"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height:30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="InvRepairInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[4022]')" queryData="InvRepairInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--保管员 记账员-->
        <selector :isVisible="false" :isBatch=false :selectType="3" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getperson" ref="person"></selector>
        <!--返修so号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Repair/GetSoCodePopupList'" @callback="getsocode" ref="socode"></selector>
        <!--入库单号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Repair/GetInStockNoPopupList'" @callback="getbaseorderno" ref="baseorderno"></selector>
        <!--选择货位号-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Inv/Repair/GetPositionCodePopupList'" @callback="getcargo" ref="cargo"></selector>

    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui';
    export default {
        name: '2_repairview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_repairview'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                dataDetail:{
                    Head:{}
                },
                oldDataDetail: '',
                personType: 1, // 选择人员的类型
                btn: {
                    Pro: false,
                    repair_qty: false,
                    audit: false,
                },
                selectData: [],
                enrepairqty: '',
                canrepqty: '',
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                code: '',
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('2_repairview', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.issueDeptType = Array.methods.getIssueDept();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'prorelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4022]"),this.$t("getapi[6588]"));
            },
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('InvRepairInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            //type 1 一览权限 、2 编辑界面权限
            authority(type) {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (type == 1) {
                    //只读权
                    if (that.$limits.ReadOnlyRightsView('plv2', 209, 1, that.total)) {
                        if (that.total > 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                    }
                    //操作权限-查询级别
                    var limits = that.$limits.OperationAuthorityView('plv2', 209, 1, that.total);
                    // limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
                    switch (limits) {
                        case -1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        case 1:
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                            break;
                        case -2:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            break;
                        case 2:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            break;
                        case -3:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            break;
                        case 3:
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            break;
                        default:
                            break;
                    }
                }

                //管理界面
                if (type == 2) {
                    if (that.$limits.authority('plv2', 272, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 272, 1) == 2) {
						if (that.$limits.authority('plv3', 272,1) == 0) {
							that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
						}
                        //操作权
                        if (that.$limits.authority('plv3', 272,1) == 1) {
                            //编辑级
                            if (that.dataDetail.Head.order_status == 0) {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,print,export,execute');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,print,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 272, 1) == 2) {
                            //删除级
                            if(!that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){
                                if (that.dataDetail.Head.order_status == 0) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,print,export,execute');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,print,export');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,print,export,refresh');
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this
                that.btn.audit = false
                if(that.dataDetail.Head.order_status == 0){
                    that.btn.audit = true
                } else {
                    that.btn.audit =  false
                }
                that.btn.Pro = false
                if(that.selectData.length  == 1){
                    that.btn.Pro = true
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_repairview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.SelectIndex = tab.name;
                that.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'InvRepairInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Inv/Repair/RepairViewDataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.order_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.order_no
                                that.getDetail(row.order_no)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow)
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.order_no
                        that.getDetail(row.order_no)
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 0
                that.code = ''
                that.dataDetail.Head = {
                    order_no: '',
                    finance_date: '',
                    finance_status: -1,
                    create_time: '',
                    create_person: '',
                    modify_person: '',
                    modify_time: '',
                    so_code: '',
                    so_type: '',
                    so_status: '',
                    audit_time: '',
                    audit_person: '',
                    order_status: 0,
                    part_code: '',
                    part_version: '',
                    cargoposition_code: '',
                    so_qty: 0,
                    start_routing_sequence_no: 0,
                    repair_qty: 0,
                    enrec_qty: '',
                    finish_qty: '',
                    routing_sequence_no: 0,
                    routing_short_name: '',
                    workcenter_code: '',
                    remark: '',
                    issue_dept: '',
                    line_net_total_amount: 0,
                    unit_price: 0,
                    keep_person: '',
                    regist_person: '',
                    last_routing_sequence_no: 0,
                    rec_material_unit: 0,
                    rec_man_unit: 0,
                    rec_charge_unit: 0,
                    rec_material_amount: 0,
                    rec_man_amount: 0,
                    rec_charge_amount: 0,
                    rec_charge_material_unit: 0,
                    rec_charge_material_amount: 0,
                    rec_carry_man_unit: 0,
                    rec_carry_man_amount: 0,
                    rec_carry_charge_unit: 0,
                    rec_carry_charge_amount: 0,
                    batch_no: '',
                    sequence_no: '',
                    base_order_no: '',
                    base_line_no: 0,
                    first_repair_flag: 0,
                    rec_carry_material_unit: 0,
                    rec_carry_material_amount: 0,
                    rec_outsource_unit: 0,
                    rec_outsource_amount: 0,
                    cargo_qty: 0
                }
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority(2);
            },
            // 刷新
            reflash() {
                let that = this;
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 0){
                                that.getView();
                                that.confirmAdd()
                            } else {
                                that.getView();
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Inv/Repair/RepairViewExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "InvRepairInfo",
                    fromname: that.$t('getapi[4022]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            // 保存
            save() {
                let that = this;
                that.dataDetail.Head.repair_qty = parseFloat(that.dataDetail.Head.repair_qty)
                that.dataDetail.Head.enrec_qty = parseFloat(that.dataDetail.Head.enrec_qty)
                that.dataDetail.Head.LangType=that.$processdata.getLang()
                let parm = that.dataDetail.Head
                that.$http.urlpost('/Inv/Repair/RepairSaveData', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Inv/Repair/GetRepairInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority(2);
                        that.btnauthority()
                    }
                    loadingInstance.close()
                });
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange2(val){
                let that = this;
                that.selectData2 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData2.push(val[i]);
                }
                that.btnauthority()
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            order_no: that.dataDetail.Head.order_no,
                            order_status: that.dataDetail.Head.order_status,
                            modify_time: that.dataDetail.Head.modify_time
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Inv/Repair/DelRepairBill', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            expsfinancestatus(val){
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1901]')//'核算';
                } else if (val == 1) {
                    return that.$t('getapi[3753]')//'记账';
                } else if (val == 2) {
                    return that.$t('getapi[3754]')//'月结';
                } else {
                    return '';
                }
            },
            selectperson(val){
                let that = this;
                that.personType = val
                that.$refs.person.clearInput(true);
            },
            getperson(data){
                let that = this
                console.log(data)
                if(that.personType == 1){
                    that.dataDetail.Head.keep_person = data.name
                } else if(that.personType == 2){
                    that.dataDetail.Head.regist_person = data.name
                }
            },
            // 选择货位
            selectcargo(row){
                let that = this;
                if(that.dataDetail.Head.so_code == ''){
                    that.$message.warning(that.$t('getapi[8844]'))//请先选择返修SO号
                    return
                }
                let param = {
                    so_code: that.dataDetail.Head.so_code,
                    part_code: that.dataDetail.Head.part_code,
                    part_version: that.dataDetail.Head.part_version,
                    order_status: that.dataDetail.Head.order_status
                }
                that.$refs.cargo.clearInput(true,param);
            },
            getcargo(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.cargoposition_code = data.cargo_position
                that.dataDetail.Head.batch_no = data.batch_no
                that.dataDetail.Head.sequence_no = data.sequence_no
                that.dataDetail.Head.cargo_qty = data.qty_on_hand
            },
            selectsocode(){
                let that = this;
                that.$refs.socode.clearInput(true);
            },
            getsocode(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.finish_qty = data.finish_qty.toString()
                that.dataDetail.Head.part_code = data.part_code
                that.dataDetail.Head.part_version = data.part_version
                that.dataDetail.Head.so_qty = data.plan_finish_qty
                that.dataDetail.Head.routing_sequence_no = data.routing_sequence_no
                that.dataDetail.Head.so_code = data.so_code
                that.dataDetail.Head.so_status = data.so_status
                that.dataDetail.Head.so_type = data.so_type
                that.dataDetail.Head.routing_short_name = data.workproc_name
                if(that.dataDetail.Head.so_type == '返修工单' && that.dataDetail.Head.finish_qty == 0){
                    let parm = {
                        order_no: that.dataDetail.Head.order_no,
                        so_code: that.dataDetail.Head.so_code,
                        so_qty: that.dataDetail.Head.so_qty
                    }
                    that.$http.urlpost('/Inv/Repair/GetCanRepairNumBySoCode', parm, function (res) {
                        if (res.Success == 1) {
                            that.enrepairqty = res.DataContent.toString()
                            that.dataDetail.Head.enrec_qty = that.enrepairqty
                            that.dataDetail.Head.repair_qty = parseFloat(that.enrepairqty)
                        }
                    });
                } else {
                    that.enrepairqty = parseFloat(that.dataDetail.Head.so_qty)
                    that.btn.repair_qty = true
                }
                that.dataDetail.Head.cargo_qty = 0
                that.dataDetail.Head.cargoposition_code = ''
            },
            selectbaseorderno(){
                let that = this
                if(that.dataDetail.Head.so_code == ''){
                    that.$message.warning(that.$t('getapi[8844]'))//'请先选择返修SO号'
                    return
                }
                let param = {
                    so_code: that.dataDetail.Head.so_code,
                    so_type: that.dataDetail.Head.so_type,
                    finish_qty: that.dataDetail.Head.finish_qty,
                    part_code: that.dataDetail.Head.part_code,
                    part_version: that.dataDetail.Head.part_version
                }
                that.$refs.baseorderno.clearInput(true, param);
            },
            getbaseorderno(data){
                let that = this
                that.dataDetail.Head.base_line_no = data.line_no
                that.dataDetail.Head.base_order_no = data.order_no
                let parm = {
                    order_no: that.dataDetail.Head.order_no,
                    inv_order_no: data.order_no,
                    line_no: data.line_no
                }
                that.$http.urlpost('/Inv/Repair/GetCanRepairNumByInvOrderNo', parm, function (res) {
                    if (res.Success == 1) {
                       that.canrepqty = res.DataContent.toString()
                        if(that.dataDetail.Head.so_type == '返修工单' && that.dataDetail.Head.finish_qty == 0){
                            if(that.canrepqty > that.enrepairqty){
                                that.dataDetail.Head.enrec_qty = that.enrepairqty
                                that.dataDetail.Head.repair_qty = parseFloat(that.dataDetail.Head.enrec_qty)
                            } else {
                                that.dataDetail.Head.enrec_qty = that.canrepqty
                                that.dataDetail.Head.repair_qty = parseFloat(that.dataDetail.Head.enrec_qty)
                            }
                        } else {
                            if(that.canrepqty > that.enrepairqty){
                                that.dataDetail.Head.enrec_qty = that.enrepairqty
                            } else {
                                that.dataDetail.Head.enrec_qty = that.canrepqty
                            }
                            that.dataDetail.Head.repair_qty = 0
                        }
                    }
                });
                /*console.log(data)
                that.dataDetail.Head.base_order_no = data.order_no
                that.dataDetail.Head.base_line_no = data.line_no*/
            },
            audit(){
                let that = this
                that.btn.audit=false;
                that.dataDetail.Head.repair_qty = parseFloat(that.dataDetail.Head.repair_qty)
                that.dataDetail.Head.LangType=that.$processdata.getLang()
                let parm = that.dataDetail.Head
                that.$http.urlpost('/Inv/Repair/RepairAuditOrder', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }

                    that.getDetail(that.code)
                    
                });
            },
            // 生产业务图
            getPro(){
                let that = this
                that.$store.commit('setSharedParams',that.selectData[0]);
                let item = {
                    label: '生产关系图',
                    name: 'prorelation',
                    path: '/prorelation/repair',
                    url: '/prorelation/repair',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/prorelation/repair'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            print(){
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.Head.order_no)){ return; }
                that.$refs.SetBtn.SetOneBtnEnable('print', false);
                that.loading = true;
                let parm = {
                po_no: that.dataDetail.Head.order_no,
                TemplateName: '18生产返修单.xlsx'
                };
                that.$http.urlpost('/Print/FXDPrint', parm, function (res) {
                that.$refs.SetBtn.SetOneBtnEnable('print', true);
                if (res.Success == 1) {
                let hrefurl = res.Key;
                window.open(hrefurl);
                } 
                that.loading = false;
                });

            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 272,1) < 1){
                    return false
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }

    /deep/.el-table .hidden-row {
        display: none;
    }
</style>
